import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  CssBaseline,
  Drawer,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { chat } from "../Config/MockData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Config/fontAwesomeConfig";
import { useDispatch, useSelector } from "react-redux";
import { getLoadingStatus, getLogo, sendmessage } from "../Redux/Public/chataction";
import { storage } from "../Config/Storage";
import TypingText from "../Config/Typingtext";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "react-router-dom"

const Chatarea = () => {

  const dispatch = useDispatch();
  const theme = useTheme();
  const [searchParams] = useSearchParams()
  const chatEndRef = useRef(null);
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));
  const isIpad = useMediaQuery(theme.breakpoints?.down("lg"));
  const isLargeDevice = useMediaQuery(theme.breakpoints?.down("lg"));
  const { list, loading, details } = useSelector((state) => state?.ChatData) || {};
  const [message, setMessage] = useState("");
  const [chatmess, setChatmess] = useState(chat);
  const [recentList, setRecentList] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [checkTypingStatus, setCheckTypingStatus] = useState(false);
  const [open, setOpen] = React.useState(isMobile || isIpad ? false : true);
  const [img, setImg] = useState("")
  const textBoxRefs = useRef([]);

  const handleFocus = (event) => {
    event.preventDefault();
    setIsFocused(false);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };

  useEffect(() => {
    dispatch(getLogo({ key: searchParams.get("id") }));
    dispatch(getLoadingStatus(true));
    function handleResize() {
      if (window.innerWidth >= 1200) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }

    // Attach the event listener to the window object
    window.addEventListener("resize", handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Re-render page on list change
  useEffect(() => {
    textBoxRefs.current.forEach((ref) => {
      if (ref && ref.scrollHeight > ref.clientHeight) {
        ref.classList.add("overflow");
      }
    });
    setCheckTypingStatus(false)
    if (list) {
      setChatmess([...chatmess, { image: require("../assests/w-logo 1@2x.png"), mess: "", reply: list.reply }]);
      setCheckTypingStatus(true)
    }
    if (details) {
      setChatmess([...chatmess, { image: require("../assests/w-logo 1@2x.png"), mess: "", reply: details.welcome_message }]);
      setImg(details?.logo_url)
    }
  }, [list, details]);


  // Re-render page on chatmess change
  useEffect(() => {
    if (chatEndRef.current) {
      const scrollHeight = chatEndRef.current.scrollHeight;
      const clientHeight = chatEndRef.current.clientHeight;
      const scrollToHeight = scrollHeight - clientHeight;
      chatEndRef.current.scrollTo(0, scrollToHeight);
    }
    storage.set.chat(chatmess);
  }, [chatmess]);

  //Send message function
  const handleSendMessage = async () => {
    if (checkTypingStatus) {
      setRecentList((prevRecentList) => {
        // Update all items in recentList to set clicked to false
        return prevRecentList.map((item) => {
          return { ...item, clicked: false };
        });
      });

      // Dispatch sendmessage action
      let data = {
        query: `${message}`,
        chat_history: list?.chat_history ? list?.chat_history : [],
        fetched_docs_ids: list?.fetched_docs_ids ? list?.fetched_docs_ids : []
      };
      dispatch(sendmessage(data));

      if (message.trim() !== "") {
        setChatmess([...chatmess, { image: require("../assests/user.png"), mess: message, reply: "" }]);
        // Update recentList after the state has been updated
        setRecentList((prevRecentList) => {
          // Create a new array with the new message appended to the beginning
          const newRecentList = [
            { image: require("../assests/user.png"), text: message, clicked: true, index: chatmess.length },
            ...prevRecentList,
          ];
          return newRecentList;
        });
        setMessage(""); // Clear the TextField after sending the message
      }
    }
    setCheckTypingStatus(false)
  };

  //Handle send message on enter
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default form submission
      if (message.length !== 0) handleSendMessage();
    }
  };
  //Handle clear chat history
  const handleDelete = () => {
    setChatmess([]);
    dispatch(getLogo({ key: "EXT_CLIENT_000020" }));
    setRecentList([]);
  };

  //Handle Scroll on select from history
  const handleClick = (index, i) => {
    const targetElement = textBoxRefs.current[index];
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
    setRecentList((prevRecentList) =>
      prevRecentList.map((item, ind) => ({
        ...item,
        clicked: ind === i,
      }))
    );


  };

  //Style CSS
  const Style = {
    grad: {
      background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
      border: "2px solid",
      borderRadius: "10px",
      borderColor: " #02010100",
      width: "10%",
      minWidth: "950px",
      ml: 2,
      maxWidth: "100%", // Default max width
      height: "fit-content",
    },
    grad1: {
      background: "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
      border: "2px solid",
      borderRadius: "10px",
      borderColor: " #02010100",
      width: "100%",
      ml: 2,
      maxWidth: "100%", // Default max width
      height: "fit-content",
      pr: 2,
    },
    overflow: {
      maxWidth: "90%", // Width when overflow occurs
    },
    logo: {
      color: "#343568",
      fontSize: "20px",
      fontWeight: 700,
    },
    logo1: {
      color: "#343568",
      fontSize: "18px",
      fontWeight: 600,
    },
    button: {
      borderRadius: "50%",
      bgcolor: message.length === 0 ? "#C8C8C8" : "#343568",
      height: "40px",
      width: "40px",
      "&.MuiButton-root": { minWidth: "40px" },
      "&.MuiButton-root:hover": {
        borderRadius: "50%",
        bgcolor: "#343568",
      },
    },
    input: {
      border: "none",
      bordeRadius: "50px",
      "& .MuiInputBase-root": {
        background: isFocused
          ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box"
          : "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
        border: isFocused ? "none" : "2px solid",
        bordeRadius: "50px",
        borderColor: " #02010100",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          bordeRadius: "50px",
          borderColor: "transparent", // Removes the border
        },
        "&:hover fieldset": {
          borderColor: "transparent", // Removes the border on hover
        },
        "&.Mui-focused fieldset": {
          borderColor: "transparent", // Removes the border when focused
        },
      },
    },
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  return (
    <Grid container>
      <CssBaseline />
      <AppBar
        sx={{
          bgcolor: "#ffffff",
          display: "flex",
          boxShadow: "none",
          borderBottom: "2px solid rgba(0, 0, 0, 0.06)",
          pt: 1.5,
          pb: 1.5,
          "&.MuiAppBar-root": {
            position: "unset",
          },
        }}>
        <Toolbar sx={{
          display: "flex",
          justifyContent: "end",
          "&.MuiToolbar-root": {
            minHeight: "16px"
          }
        }}>
          <Box
            sx={{
              border: 1,
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              width: "100%",
            }}>
            {!open && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  color: "#B2C1F0",
                  display: { xs: "flex", lg: "none" },
                  width: "50px",
                  height: "50px",
                  marginRight: "auto",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <MenuIcon sx={{ fontSize: "35px" }} />
              </IconButton>
            )}
            <img
              style={{
                height: "60px",
                width: "100px",
                // borderRadius: "60px",
                margin: "26px",
              }}
              src={img}
              alt=""
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        onClose={() => setOpen(false)}
        sx={{
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "350px",
            boxSizing: "border-box",
            maxHeight: "100%",
          },
          ml: "30px",
          mr: "30px",
        }}
        // ref={divRef2}
        id="drawer"
        variant={isLargeDevice ? "temporary" : "persistent"}
        anchor="left"
        open={open}>
        <Grid>
          <Box sx={{ m: 2, display: "flex", maxHeight: "200px", position: "relative", mt: '20px' }}>
            <img width={"89px"} height={"61px"} src={require("../assests/w-logo 1@2x.png")} alt="w-logo"/>
            <Box
              sx={{
                ml: 2,
                mt: 1,
                mb: 3,
              }}>
              <Typography sx={Style.logo}>WORX</Typography>
              <Typography sx={Style.logo1}>AI Assistant</Typography>
            </Box>
            {open && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerClose}
                edge="start"
                sx={{
                  color: "#B2C1F0",
                  display: { xs: "flex", lg: "none" },
                  ml: "5px",
                  position: "absolute",
                  right: "0px",
                }}>
                <CloseIcon sx={{ fontSize: "35px" }} />
              </IconButton>
            )}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
              // minHeight: { md: "60svh", lg: "65svh", xl: "79svh" },
              height: "calc(100vh - 210px)",
              width: "90%",
              borderRadius: "10px",
              ml: 2,
              // p: "10px",
            }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", p: "10px" }}>
              <Typography sx={{ textTransform: "uppercase", color: "#343568", fontSize: "20px" }}>Cronologia</Typography>
              <IconButton
                sx={{
                  border: "1px solid #FF6151",
                  "&.MuiIconButton-root": {
                    p: "5px",
                  },
                }}
                disabled={recentList.length === 0 ? true : false}
                onClick={handleDelete}>
                <DeleteIcon sx={{ color: "#FF6151", fontSize: "18px" }} />
              </IconButton>
            </Box>
            <Box
              className="chatbox"
              sx={{
                maxHeight: "450px",
                overflow: "scroll",
                mt: 2,
              }}>
              {recentList.length === 0 ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                  <Typography sx={{ fontSize: "18px" }}>Nessun dato</Typography>
                </Box>
              ) : (
                recentList.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      ml: 2,
                      position: "relative",
                      mt: 1,
                      width: "100%",
                      boxShadow: "1px solid gray",
                      pr: 0
                    }}
                    style={{ marginLeft: 0, marginTop: "5px" }}>
                    <Button
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        margin: "0px 10px 5px 10px",
                        boxShadow: "1px 3px 3px 0px #00000026",
                        bgcolor: "white",
                        // // border: "1px solid #EBEEFF",
                        // borderRadius: "8px",
                        background: item.clicked
                          ? "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box"
                          : "linear-gradient(#fff, #fff) padding-box, linear-gradient(#EBEEFF, #EBEEFF) border-box",
                        border: "2px solid",
                        bordeRadius: "10px",
                        borderColor: " #02010100",
                        p: 1,
                        width: "100%",
                        textTransform: "none",

                        "&.MuiButton-root:hover": {
                          background:
                            "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                          border: "2px solid",
                          bordeRadius: "10px",
                          borderColor: " #02010100",
                        },
                        "&.MuiButton-root:active": {
                          background:
                            "linear-gradient(#fff, #fff) padding-box, linear-gradient(to right, #3542FF 0%, #55F7FF 100%) border-box",
                          border: "2px solid",
                          bordeRadius: "10px",
                          borderColor: " #02010100",
                        },
                      }}
                      onClick={() => handleClick(item.index, index)}>
                      <img src={require("../assests/message.png")} alt="messageImg"/>
                      <Typography sx={{ ml: 1, textAlign: "left", overflow: "hidden", maxWidth: "500px", textOverflow: "ellipsis", color: "#000000" }}>
                        {item.text}
                      </Typography>
                    </Button>
                  </Box>
                ))
              )}
            </Box>
          </Box>
        </Grid>
      </Drawer>
      {
        searchParams.get("id") === null || searchParams.get("id") === undefined || searchParams.get("id") === "" ?
          <>
            <Box sx={{
              height: "10%",
              width: isMobile || isIpad ? "100%" : "calc(100% - 350px)",
              borderRadius: "10px",
              p: { xs: 2, sm: 2 },
              ml: "auto",
            }}>
              <Box
                sx={{
                  backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                  borderRadius: "20px",
                  // width: "95%",
                  minHeight: "450px",
                  p: 2,
                  m: { xs: 3, sm: 3, md: 3, lg: 3 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                <Typography sx={{ fontSize: "30px" }} component={"h1"}> Client Id Not Found</Typography>
              </Box>
            </Box>
          </>
          :
          <>
            <Box
              sx={{
                height: "10%",
                width: isMobile || isIpad ? "100%" : "calc(100% - 350px)",
                borderRadius: "10px",
                p: { xs: 2, sm: 2 },
                ml: "auto",
              }}>
              <Box
                sx={{
                  backgroundImage: "linear-gradient(to right,#E9EBFF, #F6F2FF,#EEFDFF)",
                  borderRadius: "20px",
                  // width: "95%",
                  // minHeight: "300px",
                  height: "calc(100vh - 210px)",
                  p: 2,
                  m: { xs: 2, sm: 4 },
                }}>
                <Box
                  className="chatbox"
                  sx={{
                    overflow: "scroll",
                    height: "calc(100% - 67px)"
                    // minHeight: { md: "45svh", lg: "45svh", xl: "70svh" },
                    // maxHeight: "420px",
                    // pb: 3,
                  }}
                  ref={chatEndRef}>
                  <>
                    {!loading &&
                      chatmess.map((item, index) => (
                        <Box sx={{ display: "flex", height: "auto", mt: 2 }} key={index}>
                          <Box
                            sx={{
                              bgcolor: "white",
                              borderRadius: "50%",
                              width: "50px",
                              height: "50px",
                              p: item.reply !== "" ? 1.4 : 0.6,
                            }}>
                            <img
                              style={{ width: item.reply !== "" ? "30px" : "40px", height: item.reply !== "" ? "25px" : "40px" }}
                              src={item.image}
                              alt="w-logo"
                            />
                          </Box>
                          {item.reply !== "" ? (
                            <Box ref={(el) => (textBoxRefs.current[index] = el)} sx={{ ...Style.grad1, wordBreak: "initial" }}>
                              <Box sx={{ ml: 1, mt: 1.5, mb: 1.5 }}>
                                <TypingText text={item.reply} chatEndRef={chatEndRef} setCheckTypingStatus={setCheckTypingStatus} checkTypingStatus={checkTypingStatus} />
                              </Box>
                            </Box>
                          ) : (
                            <>
                              <Box ref={(el) => (textBoxRefs.current[index] = el)} id={index} className="scroll-to" sx={{ ...Style.grad1, wordBreak: "initial" }}>
                                <Typography sx={{ ml: 1, mt: 1.4, mb: 1.4 }}>{item.mess}</Typography>
                              </Box>
                            </>
                          )}
                        </Box>
                      ))}
                    {loading && (
                      <Box sx={{ display: "flex", height: "auto", mt: 2 }}>
                        <Box sx={{ bgcolor: "white", borderRadius: "50%", width: "50px", height: "50px", p: 0.6 }}>
                          <img style={{ width: "40px", height: "40px" }} src={require("../assests/w-logo 1@2x.png")} alt="W-logo"/>
                        </Box>
                        <Box sx={Style.grad}>
                          <Box sx={{ display: "flex", wordBreak: "break-all", justifyContent: "space-evenly", p: 2, width: "15% " }}>
                            {/* <Skeleton variant="circular" width={20} height={20} />
                      <Skeleton variant="circular" width={20} height={20} />
                      <Skeleton variant="circular" width={20} height={20} /> */}
                            <CircularProgress />
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {
                      loading !== undefined ? null : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "5px" }}>
                        <CircularProgress />
                      </Box>
                    }
                  </>
                </Box>
                <Box>
                  <TextField
                    autoFocus
                    fullWidth
                    multiline
                    maxRows={5}
                    placeholder="Inserisci messaggio..."
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown} // Attach keydown event listener
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button disabled={message.length === 0 ? true : false} sx={Style.button} onClick={handleSendMessage}>
                            <FontAwesomeIcon icon={["far", "paper-plane"]} color="white" style={{ marginRight: "2px" }} />
                          </Button>
                        </InputAdornment>
                      ),
                      // disableUnderline: true, // Remove the default underline
                    }}
                    sx={Style.input}
                  />
                </Box>
              </Box>
            </Box>
          </>
      }
    </Grid>
  );
};

export default Chatarea;
